import React from "react";
import { useI18n } from "@/i18n";

function LegalPage({ pageKey }) {
  const { dict } = useI18n();
  const page = dict.pages[pageKey];
  return (
    <section className="bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="mb-10">
          <div className="font-mono-brand text-[11px] uppercase tracking-[0.24em] text-[var(--brand-terracotta)] mb-3">
            xorzeni.com · legal
          </div>
          <h1 className="font-serif-brand text-4xl lg:text-5xl text-[var(--brand-navy)] font-semibold mb-3">
            {page.title}
          </h1>
          <div className="text-sm text-[var(--brand-ink)]/60">{page.updated}</div>
        </div>
        <div className="rule-navy mb-8" />
        <p className="text-[var(--brand-ink)]/85 leading-relaxed mb-6">{page.intro}</p>
        <div className="legal-prose">
          {page.sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${pageKey}-${i}`}>
              <h2>{s.h}</h2>
              <p>{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function PrivacyPolicy() {
  return <LegalPage pageKey="privacy" />;
}
export { LegalPage };
